import { Component, OnInit } from '@angular/core';
import { BreadcrumbComponent, PaginationComponent } from '../../../shared/components';
import { PageEvent } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-listado-ac-ejecucion',
  templateUrl: './listado-ac-ejecucion.component.html',
  styleUrls: ['./listado-ac-ejecucion.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    BreadcrumbComponent,
    PaginationComponent
]
})
export class ListadoAcEjecucionComponent implements OnInit {
  
  public breadcrumbs: any = {
    title: 'Seguimiento de Asistencia',
    breadcrumbs: [
      { label: 'HOME', link: '/home' },
      { label: 'Seguimiento de Asistencia', link: '' }
    ]
  };
  public accs: any[] = [];
  public pageSizes = [5, 10, 15, 25, 50];
  public currentPage: number = 1;
  public pageSize: number = 5;
  public totalAccs: number = 0;
  public filtrosAplicados: any = {};

  constructor(
    private readonly _router: Router,
  ) { }

  ngOnInit() {
    this.accs = [
    {
      acca_id: 'AC-001',
      acca_nombre: 'Capacitación en Seguridad Laboral',
      cuse_nombre: 'Prevención de Riesgos',
      even_inicio_ejecucion: '2025-03-10',
      even_fin_ejecucion: '2025-03-15',
      estado: { id: 2, nombre: 'En Curso' }
    },
    {
      acca_id: 'AC-002',
      acca_nombre: 'Formación en Liderazgo',
      cuse_nombre: 'Habilidades Directivas',
      even_inicio_ejecucion: '2025-01-20',
      even_fin_ejecucion: '2025-01-25',
      estado: { id: 3, nombre: 'Finalizado' }
    },
    {
      acca_id: 'AC-003',
      acca_nombre: 'Capacitación Técnica en Excel Avanzado',
      cuse_nombre: 'Excel Avanzado',
      even_inicio_ejecucion: '2025-04-01',
      even_fin_ejecucion: '2025-04-05',
      estado: { id: 1, nombre: 'Por Iniciar' }
    },
    {
      acca_id: 'AC-003',
      acca_nombre: 'Capacitación Técnica en Excel Avanzado',
      cuse_nombre: 'Excel Avanzado',
      even_inicio_ejecucion: '2025-04-01',
      even_fin_ejecucion: '2025-04-05',
      estado: { id: 1, nombre: 'Por Iniciar' }
    },
    {
      acca_id: 'AC-003',
      acca_nombre: 'Capacitación Técnica en Excel Avanzado',
      cuse_nombre: 'Excel Avanzado',
      even_inicio_ejecucion: '2025-04-01',
      even_fin_ejecucion: '2025-04-05',
      estado: { id: 1, nombre: 'Por Iniciar' }
    }
  ];
    this.totalAccs = this.accs.length;
  }

  aplicarFiltrosSeleccionados(offset: any, limit: any, filtros: any) {

  }

  onPageChange(event: PageEvent): void {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.aplicarFiltrosSeleccionados(this.currentPage, this.pageSize, this.filtrosAplicados);
  }

  changePageSize(newSize: number): void {
    this.pageSize = +newSize;
    this.currentPage = 1;
    const offset = 0;
    this.aplicarFiltrosSeleccionados(offset, this.pageSize, this.filtrosAplicados);
  }

  goGestionarAsistencia(id: any) {
    this._router.navigate(['/listado-ac-ejecucion/seguimiento-asistencia', id]);
  }

  goHome() {
    this._router.navigate(['/home']);
  }
}
